import {
  Component,
  ElementRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import * as debug from 'debug';

@Component({
  selector: 'user-action-modal',
  templateUrl: 'user-action-modal.html',
})
export class UserActionModalComponent {
  log = debug('app:UserReviewModal');

  @Input()
  set image(image: string) {
    if (image) {
      this.modalImage = image;
    }
  }

  @Input()
  set header(header: string) {
    if (header) {
      this.modalHeader = header;
    }
  }

  @Input()
  set description(description: string) {
    if (description) {
      this.modalDescription = description;
    }
  }

  @Output()
  close = new EventEmitter();

  modalImage?: string;
  modalHeader?: string;
  modalDescription?: string;

  constructor(private el: ElementRef) {}

  dismiss() {
    // this.el.nativeElement.classList.remove('show');
    // this.el.nativeElement.classList.add('hidden');
    this.close.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/user-action-modal/user-action-modal.ts